module.exports = __webpack_public_path__ + "media/mosaics/Mosaics-Room-Playroom-4ffa430f.jpg";